import { render, staticRenderFns } from "./EntryControls.vue?vue&type=template&id=47bb1b4e&scoped=true&"
import script from "./EntryControls.vue?vue&type=script&lang=js&"
export * from "./EntryControls.vue?vue&type=script&lang=js&"
import style0 from "./EntryControls.vue?vue&type=style&index=0&id=47bb1b4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bb1b4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47bb1b4e')) {
      api.createRecord('47bb1b4e', component.options)
    } else {
      api.reload('47bb1b4e', component.options)
    }
    module.hot.accept("./EntryControls.vue?vue&type=template&id=47bb1b4e&scoped=true&", function () {
      api.rerender('47bb1b4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/inventory-items/components/items-table/EntryControls.vue"
export default component.exports